import { Component, ElementRef, AfterViewInit, EventEmitter, Inject, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroupDirective, Validators } from '@angular/forms';
import { Constants } from '../../../../../core/services/constants.service';
import { HttpService } from '../../../../../core';
import { ToastrService } from 'ngx-toastr';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { fromEvent } from 'rxjs';
import { debounceTime, distinctUntilChanged, map, tap } from 'rxjs/operators';
import { environment } from "../../../../../../environments/environment";


@Component({
    selector: 'allocate-dialog',
    templateUrl: './allocate-dialog.component.html',
    styleUrls: ['./allocate-dialog.component.scss'],
})

export class AllocateDialogComponent implements OnInit, AfterViewInit {
    SERVER_URL = environment.SERVER_URL;

    @ViewChild('search', { static: false }) search: ElementRef;

    project: any;
    selectedProperties = [];
    agencyList: any;
    isShow: boolean = false;
    agencyIds: number[];
    agencyIndex: number[] = [];
    propertyIds: number[] = [];
    currentBuildingId: any;

    isAloneProperty: boolean = false;

    searchInput: any;

    constructor(
        // private formBuilder: FormBuilder,
        private httpService: HttpService,
        // private toastrService: ToastrService,
        private dialogRef: MatDialogRef<any>,
        @Inject(MAT_DIALOG_DATA) public data: any,
    ) {

    }

    ngOnInit(): void {
        this.agencyIndex = [];
        this.propertyIds = [];
        this.project = this.data.project;
        this.isAloneProperty = this.data.isAloneProperty
        this.selectedProperties = this.data.selectedProperties;
        this.agencyIds = this.data.agencyIds;
        this.httpService.getAgencyList(this.project.id).toPromise().then((agencyList: any) => {
            this.agencyList = agencyList.data
            if (this.agencyIds.length > 0) {
                for (let i = 0; i < this.agencyList.length; i++) {
                    if (this.agencyIds.includes(this.agencyList[i].id)) {
                        this.agencyIndex.push(i)
                    }
                }
            }
        })
    }

    ngAfterViewInit(): void {
        fromEvent(this.search.nativeElement, 'keyup').pipe(
            map((event: any) => {
                return event.target.value;
            }),
            debounceTime(500),
            distinctUntilChanged(),
        ).subscribe((text: string) => {
            this.httpService.searchAgencyList(this.project.id, text).toPromise().then((agencyList: any) => {
                this.agencyList = agencyList.data
            })
        })
    }

    cancel() {
        this.dialogRef.close();
    }

    allocate(e) {
        this.isShow = e;
    }

    reset() {
        this.searchInput = null;
        this.httpService.searchAgencyList(this.project.id, '').toPromise().then((agencyList: any) => {
            this.agencyList = agencyList.data
        })
        this.agencyIds = []
        this.agencyIndex = []
    }

    agencyCheckBoxSelected(id: number) {
        return this.agencyIds.includes(id)
    }

    check($event: Event, id: number, index: number) {
        if ((<HTMLInputElement>event!.target).checked) {
            this.agencyIds.push(id);
            this.agencyIndex.push(index)
        } else {
            this.agencyIds.splice(this.agencyIds.indexOf(id), 1);
            this.agencyIndex.splice(this.agencyIndex.indexOf(index), 1)
        }
        console.log("选择的中介：" + this.agencyIds);
    }

    confirm() {
        const buildingPropertyList = []
        this.selectedProperties.forEach((selected: any, i: number) => {
            for (let i = 0; i < buildingPropertyList.length; i++) {
                // 对比相同的字段key，相同放入对应的数组
                if (buildingPropertyList[i].buildingId === selected.project.id) {
                    buildingPropertyList[i].propertyIds.push(selected.id);
                    return;
                }
            }
            // 第一次对比没有参照，放入参照
            buildingPropertyList.push({
                buildingId: selected.project.id,
                propertyIds: [selected.id]
            })
        })
        let item = {
            buildingPropertyList: buildingPropertyList,
            agencyIds: this.agencyIds
        }
        if (this.isAloneProperty) {
            this.httpService.confirmAgencyAlone(this.project.id, item).subscribe(() => {
                this.dialogRef.close();
            });
        } else {
            this.httpService.confirmAgency(this.project.id, item).subscribe(() => {
                this.dialogRef.close();
            });
        }

    }

}
